<template>
  <div class="video-paster">
    <Steps
      v-if="step1"
      :title="$t('edit.hpInfo.videoSelect')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(-1)"
      @onClickNext="onClickNextTo(2)"
    >
      <template slot="body">
        <HListWithBtn
          :rightButtonTile="$t('edit.hpInfo.videoSelect')"
          :type="3"
          @selectChange="onSelectVideoChange"
        >
          <template slot="body">
            <div class="imge-item" v-if="pasterObj.url">
              <video style="width: 100%" :src="pasterObj.url" />
            </div>
          </template>
        </HListWithBtn>
      </template>
    </Steps>

    <Steps
      v-if="step2"
      :title="$t('edit.injectInfo.setCover')"
      :isShowArrow="true"
      @clickBack="onClickPreTo(1)"
      @onClickNext="onClickNextTo(3)"
    >
      <template slot="body">
        <HListWithBtn
          :rightButtonTile="$t('edit.injectInfo.setCover')"
          :type="1"
          @selectChange="onSelectCoverChange"
        >
          <template slot="body">
            <div class="imge-item" v-if="pasterObj.posterurl">
              <img :src="pasterObj.posterurl" />
            </div>
          </template>
        </HListWithBtn>
      </template>
    </Steps>

    <Steps
      v-if="step3"
      :title="$t('edit.injectInfo.positionAdjust')"
      :isShowArrow="true"
      :isLast="true"
      displayType
      @clickBack="onClickPreTo(2)"
      @onClickFinish="onClickFinish"
    >
      <template slot="body">
        <div class="adjust-item">
          <div
            class="item"
            :class="{ seleced: selectedAdjust.type === item.type }"
            v-for="item in adjustTitles"
            :key="item.title"
            @click="onClickAdjust(item)"
          >
            <div v-if="item.img">
              <img style="width: 30px; height: 30px" :src="item.img" />
            </div>
            <div class="icon-wrapper" v-if="item.icon">
              <a-icon style="fontsize: 18px" :type="item.icon"></a-icon>
            </div>
            <span>{{ item.title }}</span>
          </div>
        </div>
        <div>
          <a-slider
            v-if="showX"
            v-model="pasterObj.rx"
            :min="-180"
            :max="180"
          />
          <a-slider
            v-if="showY"
            v-model="pasterObj.ry"
            :min="-180"
            :max="180"
          />
          <a-slider
            v-if="showZ"
            v-model="pasterObj.rz"
            :min="-180"
            :max="180"
          />
          <a-slider
            v-if="showScale"
            v-model="pasterObj.scale"
            :min="0"
            :max="1.0"
            :step="0.01"
          />
        </div>
      </template>
    </Steps>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import Steps from "../../Steps.vue";
import HListWithBtn from "../../HListWithBtn.vue";
export default {
  components: { Steps, HListWithBtn },
  props: {
    defaultValue: {
      type: Object,
    },
  },
  data() {
    return {
      step1: true,
      step2: false,
      step3: false,
      adjustTitles: [
        {
          title: this.$t('edit.injectInfo.adjust.xr'),
          type: 1,
          img: require("../../../assets/img/x-rotate.png"),
        },
        {
          title: this.$t('edit.injectInfo.adjust.yr'),
          type: 2,
          img: require("../../../assets/img/y-rotate.png"),
        },
        {
          title: this.$t('edit.injectInfo.adjust.zr'),
          type: 3,
          img: require("../../../assets/img/z-rotate.png"),
        },
        { title: this.$t('edit.injectInfo.adjust.zoom'), type: 4, icon: "search" },
      ],
      pasterObj: {
        type: "video",
        paster_id: "paster" + uuidv4(),
        url: "",
        localurl: "",
        title: "",
        posterurl: "",
        ath: 0,
        atv: 0,
        rx: 0,
        ry: 0,
        rz: 0,
        scale: 0.5,
        autoplay: true,
      },
      selectedAdjust: null,
      showX: false,
      showY: false,
      showZ: false,
      showScale: false,
    };
  },
  watch: {
    defaultValue: {
      handler: function (value) {
        if (value) {
          this.pasterObj = value;
        }
      },
      immediate: true,
      deep: true,
    },
    newPasterObj: {
      handler: function (val, oldVal) {
        if (val.ath == "" && val.atv == "") {
          const vh = getSceneViewAt();
          this.pasterObj.ath = vh.hlookat;
          this.pasterObj.atv = vh.vlookat;
        }
        this.$emit("change", this.pasterObj, oldVal);
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    newPasterObj() {
      return this.$deepClone(this.pasterObj);
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    this.$bus.$on("updatePaster", (e) => {
      if (e.paster_id == this.pasterObj.paster_id) {
        this.pasterObj.ath = e.ath;
        this.pasterObj.atv = e.atv;
      }
    });
  },
  methods: {
    initData() {
      this.selectedAdjust = this.adjustTitles[0];
      this.showX = true;
    },
    onClickPreTo(value) {
      if (value === -1) {
        this.$emit("onClickBack", this.pasterObj);
      } else if (value === 1) {
        this.step1 = true;
        this.step2 = false;
        this.step3 = false;
      } else if (value === 2) {
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      }
    },
    onClickNextTo(value) {
      if (value === 2) {
        if (!this.pasterObj.url) {
          this.$message.error(this.$t('edit.hpInfo.videoSelect'));
          return;
        }
        this.step1 = false;
        this.step2 = true;
        this.step3 = false;
      } else if (value === 3) {
        this.step1 = false;
        this.step2 = false;
        this.step3 = true;
      }
    },
    onSelectVideoChange(item) {
      this.pasterObj.url = item.url;
    },
    onSelectCoverChange(item) {
      this.pasterObj.posterurl = item.url;
    },
    onBackPre() {
      this.step1 = true;
      this.step2 = false;
    },
    onClickFinish() {
      this.$emit("saveDataToStore", {
        key: this.pasterObj.paster_id,
        data: this.pasterObj,
      });
    },
    onClickAdjust(item) {
      console.log(item);
      this.selectedAdjust = item;
      const value = item.type;
      const typeObj = {
        x: value === 1,
        y: value === 2,
        z: value === 3,
        scale: value === 4,
      };

      this.showX = typeObj.x;
      this.showY = typeObj.y;
      this.showZ = typeObj.z;
      this.showScale = typeObj.scale;
    },
  },
};
</script>

<style lang="less" scoped>
.video-paster {
  // padding: 5px 10px;
  .imge-item {
    width: 47px;
    height: 47px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  // .adjust-item {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  //   padding: 0 20px;
  //   width: 100%;
  //   .item {
  //     text-align: center;
  //     color: #8c8c8c;
  //   }
  //   .seleced {
  //     border-bottom: 2px solid;
  //     color: #ffffff;
  //   }
  // }
}
</style>